import styles from "./MyTripsButton.module.scss";
import { useMyTripsMenu } from "./useMyTripsMenu";
import { FaUser } from "@/components/Atoms/AppIcons";
import { IconButton } from "@/components/Atoms/IconButton";

export default function MyTripsButton() {
  const {
    goToTrips,
    isCheckingSession,
    isMenuOpen,
    logOut,
    openMenuOrSignIn,
    prefetchSession,
    wrapperRef,
  } = useMyTripsMenu();

  return (
    <div ref={wrapperRef} className={styles.Wrapper}>
      <IconButton
        aria-label="My trips"
        title="My trips"
        aria-busy={isCheckingSession}
        aria-expanded={isMenuOpen}
        className={isCheckingSession ? styles.Busy : undefined}
        onPointerEnter={() => void prefetchSession()}
        onFocus={() => void prefetchSession()}
        onClick={() => void openMenuOrSignIn()}
      >
        <FaUser color="white" size={20} />
      </IconButton>
      {isMenuOpen ? (
        <div className={styles.Menu}>
          <button type="button" className={styles.MenuItem} onClick={goToTrips}>
            Go to trips
          </button>
          <div className={styles.Divider} aria-hidden="true" />
          <button
            type="button"
            className={styles.MenuItem}
            onClick={() => void logOut()}
          >
            Log out
          </button>
        </div>
      ) : null}
    </div>
  );
}
